export default "/images/bookings.svg?315cb2a9045a27954b9832ec3cf41bba";